import PropTypes from 'prop-types';
import React from 'react';
import { MAINTENANCE_DUE_STATUS } from 'src/constants/maintenance';

import StatusBadge from '../ui/StatusBadge';

const MaintenanceStatusBadge = ({ status, count }) => {
  if (!count) return null;

  const { variant, statusIcon, statusLabel } = MAINTENANCE_DUE_STATUS[status];

  return (
    <StatusBadge variant={variant} icon={statusIcon}>
      {count} {statusLabel}
    </StatusBadge>
  );
};

MaintenanceStatusBadge.propTypes = {
  status: PropTypes.oneOf(['overdue', 'warning', 'healthy']).isRequired,
  count: PropTypes.number.isRequired,
};

export default MaintenanceStatusBadge;
